import {ChangeDetectionStrategy, Component, EventEmitter, Optional, Output} from "@angular/core";
import {ModalContext} from "../../ModalContext";

@Component({
  selector: "n-modal-close-button",
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <button type="button" (click)="close()"></button>`,
  styleUrls: [
    "./n-modal-close-button.css"
  ],
})
export class NModalCloseButtonComponent {

  @Output() onClose = new EventEmitter();

  constructor(@Optional() private modalCtx: ModalContext) {
  }

  close() {
    if (this.modalCtx) {
      this.modalCtx.cancel();
    }
    this.onClose.emit();
  }

}
